export default "__VITE_ASSET__BnchVGMc__"